export default __webpack_public_path__ + "static/media/MANDU-Roopmati-Pavilion.c028ab00.jpg";